/**
 * PAPPO — Alerts Service
 * Comunicação com a API de alertas de risco (/api/alerts). Só responsáveis/admin.
 */

import { apiGet, apiPost } from './api';
import type { Alert } from '../types/alert';

/** Lista os alertas do responsável (opcionalmente filtrados por status) */
export async function listAlerts(status?: string) {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return apiGet<{ alerts: Alert[]; unread_count: number }>(`/alerts${q}`);
}

/**
 * Contagem de alertas por ver (status pending).
 * Degrada graciosamente para 0 em falha (ex.: endpoint ainda indisponível).
 */
export async function getUnreadAlertCount(): Promise<number> {
  const res = await apiGet<{ count: number }>('/alerts/unread-count');
  return res.success && res.data ? res.data.count : 0;
}

/** Marca um alerta como visto */
export async function markAlertSeen(id: number) {
  return apiPost(`/alerts/${id}/seen`);
}

/** Descarta um alerta (falso alarme) */
export async function dismissAlert(id: number) {
  return apiPost(`/alerts/${id}/dismiss`);
}

/** Marca como resolvido (ação tomada) — distinto de descartar */
export async function resolveAlert(id: number) {
  return apiPost(`/alerts/${id}/resolve`);
}

/** Envia o contato adulto do alerta para a moderação (F2) e resolve o alerta */
export async function denounceFromAlert(id: number) {
  return apiPost<{ report_id: number }>(`/alerts/${id}/denounce`);
}

/** Corta o laço do filho com o contato do alerta (bloqueia + desconecta) */
export async function cutContactFromAlert(id: number) {
  return apiPost<{ child_id: number; contact_id: number }>(`/alerts/${id}/cut-contact`);
}
